import React from 'react';
import { images } from '../../Constants/imageslinks';

const PaymentMethodHeader = () => {
  return (
    <>
      <div className="flex sm:flex-row flex-col justify-between">
        <p className="font-inter font-medium text-sm leading-6">
          2. Payment details
        </p>
        <div className="flex gap-2 items-center">
          <img src={images.visa_card} alt="visa card icon" />
          <img src={images.master_card} alt="master card icon" />
          <img src={images.amex_card} alt="amex card icon" />
          <img src={images.discover_card} alt="discover card icon" />
          <p className="font-inter font-light text-[10px]">and more</p>
        </div>
      </div>
      <div className="flex items-start mt-2 gap-2">
        <img src={images.lock_icon} alt="lock icon" className="-ml-1" />
        <p className="font-inter font-light text-[10px] leading-[18px] text-dark-100">
          We protect your payment information using encryption to provide
          bank-level security.
        </p>
      </div>
    </>
  );
};

export default PaymentMethodHeader;
